module.exports = __webpack_public_path__ + "img/frame-768.9076e6a2.webp";